import { useEffect, useState } from "react";
import { Alert, Form } from "react-bootstrap";
import { ConfirmationModal } from "./modals/ConfirmationModal";

type ForceUpdateFieldProps = {
  defaultChecked?: boolean;
  productLabel: "app" | "firmware";
};

export function ForceUpdateField({
  defaultChecked = false,
  productLabel,
}: ForceUpdateFieldProps) {
  const [checked, setChecked] = useState(defaultChecked);
  const [showConfirm, setShowConfirm] = useState(false);
  const productName = productLabel === "app" ? "app" : "firmware";

  useEffect(() => {
    setChecked(defaultChecked);
  }, [defaultChecked]);

  return (
    <>
      <Form.Group className="mb-3">
        <Form.Check
          type="checkbox"
          name="forceUpdate"
          id={`forceUpdate-${productLabel}`}
          label="Force update"
          checked={checked}
          onChange={(event) => {
            if (event.target.checked) {
              setShowConfirm(true);
              return;
            }
            setChecked(false);
          }}
        />
        <Alert variant="warning" className="mt-2 mb-0 py-2 small">
          Enabling force update will block all customers from using the{" "}
          {productName} until they upgrade to this version.
        </Alert>
      </Form.Group>

      <ConfirmationModal
        title="Enable force update"
        prompt="Are you sure you want to force all the users to upgrade to this version?"
        warning="Only enable Force Update if there is critical bug fix or significant update."
        confirmButtonText="Enable force update"
        show={showConfirm}
        onShow={setShowConfirm}
        onConfirmed={async () => {
          setChecked(true);
          setShowConfirm(false);
        }}
      />
    </>
  );
}

export function isForceUpdateChecked(formData: FormData): boolean {
  return formData.get("forceUpdate") === "on";
}
